import React from "react"
import Masonry from "react-masonry-css"
import styled from "styled-components"

import { IEvent } from "../../../types/event"
import { TwitterCard, InstaCard, RadioCard } from "./EventCards"

/**
 * React masonry CSS
 */

const gutter = 15

const StyledMasonry = styled(Masonry)`
  &.masonry-grid {
    display: flex;
    margin-left: -${gutter}px; /* gutter size offset */
    width: auto;
  }
  .masonry-column {
    padding-left: ${gutter}px; /* gutter size */
    background-clip: padding-box;
  }
  .masonry-column > div {
    margin-bottom: ${gutter}px;
  }
`

const breakpointColumns = {
  default: 2,
  500: 1,
}

interface IProps {
  list: IEvent[]
}

const ThumbsEvent = ({ list }: IProps) => {
  if (list?.length === 0 || !list) {
    return null
  }

  return (
    <StyledMasonry
      breakpointCols={breakpointColumns}
      className="masonry-grid"
      columnClassName="masonry-column"
    >
      {list?.map((item, i) => {
        if (item.type === "twitter") {
          return <TwitterCard item={item} key={i} />
        }

        if (item.type === "instagram") {
          return <InstaCard item={item} key={i} />
        }

        if (item.type === "podcast") {
          return <RadioCard item={item} key={i} />
        }
      })}
    </StyledMasonry>
  )
}

export default ThumbsEvent
